import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getToken } from "./../../utils/utils";

export const fetchGroup = createAsyncThunk(
  "fetchGroup",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/controller/group/list.php";
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.group;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchGroupSearch = createAsyncThunk(
  "fetchGroupSearch",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/group/search.php?search=" +
      data;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.group;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchGroupEdit = createAsyncThunk(
  "fetchGroupEdit",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/group/details.php?id=" +
      data.id;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.group[0];
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const saveGroup = createAsyncThunk(
  "saveGroup",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/controller/group/create.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.group) return result.data.group;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const editGroup = createAsyncThunk(
  "editGroup",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/controller/group/update.php";
    const authorization = getToken();
    const options = {
      method: "put",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.group) return result.data.group;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const deleteGroup = createAsyncThunk(
  "deleteGroup",
  async (id, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/group/delete.php?id=" + id;
    const authorization = getToken();
    const options = {
      method: "delete",
      headers: { Authorization: "Bearer " + authorization },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.status) {
          return result.status;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
